import { render } from "./NewsletterDetail.vue?vue&type=template&id=faa87db0&scoped=true"
import script from "./NewsletterDetail.vue?vue&type=script&lang=js"
export * from "./NewsletterDetail.vue?vue&type=script&lang=js"

import "./NewsletterDetail.vue?vue&type=style&index=0&id=faa87db0&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa87db0"]])

export default __exports__